import { toast } from "react-toastify";
import { call, fork, put, takeLatest } from "redux-saga/effects";
import { getStudentExamApiError } from "../../../utils/studentExamPaths";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";
import { closeExamAnswersLoading } from "../../admin-modules/models/Actions";
function* getAllExams({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getAllExams, payload);
    yield put(actions.getAllExamsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getAllExamsFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* getAllExamsAndHomeworks() {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getAllExamsAndHomeworks);
    yield put(actions.getAllExamsAndHomeworksSuccess(result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to load exams");
    yield put(actions.getAllExamsAndHomeworksFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* getExamsByChapterID({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getExamsByChapterID, payload);
    yield put(actions.getExamsByChapterIdSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getExamsByChapterIdFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}
function* getChapterExam({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getChapterExam, payload);
    yield put(actions.getChapterExamSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getChapterExamFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* getChapterExamById({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getChapterExamById, payload);
    yield put(actions.getChapterExamByIdSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getChapterExamByIdFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}
function* getExamsByID({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getExamsByID, payload);
    yield put(actions.getExamsByIdSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getExamsByIdFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* getExamQuestions({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getExamQuestions, payload);
    yield put(actions.getExamQuestionsSuccess(result.data));
  } catch (error) {
    const { message, alreadyAnswered } = getStudentExamApiError(error);
    toast.error(message);
    yield put(
      actions.getExamQuestionsFail({
        alreadyAnswered,
        message,
      })
    );
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* getExamCorrection({ payload }) {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getExamCorrection, payload);
    yield put(actions.getExamCorrectionSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getExamCorrectionFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* sendAnswers(formData) {
  try {
    yield put(actions.sendAnswersLoading(true));
    const result = yield call(api.sendAnswers, formData.payload);
    yield put(
      actions.sendAnswersSuccess({
        data: result.data,
      })
    );
    formData?.action && formData?.action();
  } catch (error) {
    yield put(closeExamAnswersLoading());
    yield put(actions.sendAnswersLoading(false));
  } finally {
    yield put(actions.sendAnswersLoading(false));
  }
}

function* sendChapterExamAnswers(formData) {
  try {
    yield put(actions.sendAnswersLoading(true));
    const result = yield call(api.sendChapterExamAnswers, formData.payload);
    yield put(
      actions.sendChapterExamAnswersSuccess({
        data: result.data,
      })
    );
    formData?.action && formData?.action();
  } catch (error) {
    yield put(closeExamAnswersLoading());
    yield put(actions.sendAnswersLoading(false));
  } finally {
    yield put(actions.sendAnswersLoading(false));
  }
}

function* examRedo(formData) {
  try {
    yield put(actions.sendAnswersLoading(true));
    const result = yield call(api.examRedo, formData.payload);
    yield put(
      actions.examRedoSuccess({
        data: result.data,
      })
    );
    formData?.action && formData?.action();
    toast.success("your request is sent");
  } catch (error) {
    yield put(actions.examRedoFail());
    toast.success(error.data.message.toString());
  } finally {
    yield put(actions.sendAnswersLoading(false));
  }
}

function* getTodayChallenge() {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getTodayChallenge);
    // Response structure: { code, state, data, exam_id }
    yield put(actions.getTodayChallengeSuccess({
      data: result.data.data || result.data,
      exam_id: result.data.exam_id
    }));
  } catch (error) {
    const { response, message } = error;
    toast.error(error?.response?.data?.message || "Failed to get today's challenge");
    yield put(actions.getTodayChallengeFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* completeTodayChallenge(formData) {
  try {
    yield put(actions.sendAnswersLoading(true));
    const result = yield call(api.completeTodayChallenge, formData.payload);
    // Response structure: { code, state, data }
    yield put(
      actions.completeTodayChallengeSuccess({
        data: result.data.data || result.data,
      })
    );
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.completeTodayChallengeFail());
    toast.error(error?.response?.data?.message || "Failed to complete challenge");
  } finally {
    yield put(actions.sendAnswersLoading(false));
  }
}

function* getPreviousChallenges() {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getPreviousChallenges);
    // Response structure: { code, state, data }
    yield put(actions.getPreviousChallengesSuccess(result.data.data || result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error?.response?.data?.message || "Failed to get previous challenges");
    yield put(actions.getPreviousChallengesFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

function* getStreakLeaderboard() {
  try {
    yield put(actions.addExamsLoading(true));
    const result = yield call(api.getStreakLeaderboard);
    // Response structure: { code, state, data: { users, users_subject } }
    yield put(actions.getStreakLeaderboardSuccess({
      data: result.data.data || result.data,
    }));
  } catch (error) {
    const { response, message } = error;
    toast.error(error?.response?.data?.message || "Failed to get leaderboard");
    yield put(actions.getStreakLeaderboardFail());
  } finally {
    yield put(actions.addExamsLoading(false));
  }
}

export default function* chapterExamSaga() {
  yield takeLatest(Types.GET_ALL_EXAMS_REQUEST, getAllExams);
  yield takeLatest(Types.GET_ALL_EXAMS_AND_HOMEWORKS_REQUEST, getAllExamsAndHomeworks);

  yield takeLatest(Types.GET_EXAMS_BY_CHAPTER_ID_REQUEST, getExamsByChapterID);
  yield takeLatest(Types.GET_EXAMS_BY_ID_REQUEST, getExamsByID);
  yield takeLatest(Types.GET_EXAM_QUESTIONS_REQUEST, getExamQuestions);
  yield takeLatest(Types.GET_EXAM_CORRECTION_REQUEST, getExamCorrection);

  yield takeLatest(Types.SEND_ANSWERS_REQUEST, sendAnswers);
  yield takeLatest(
    Types.SEND_CHAPTER_EXAM_ANSWERS_REQUEST,
    sendChapterExamAnswers
  );

  yield takeLatest(Types.EXAM_REDO_REQUEST, examRedo);

  yield takeLatest(Types.GET_CHAPTER_EXAM_REQUEST, getChapterExam);
  yield takeLatest(Types.GET_CHAPTER_EXAM_DETAILS_REQUEST, getChapterExamById);

  // Daily Challenge
  yield takeLatest(Types.GET_TODAY_CHALLENGE_REQUEST, getTodayChallenge);
  yield takeLatest(Types.COMPLETE_TODAY_CHALLENGE_REQUEST, completeTodayChallenge);
  yield takeLatest(Types.GET_PREVIOUS_CHALLENGES_REQUEST, getPreviousChallenges);
  yield takeLatest(Types.GET_STREAK_LEADERBOARD_REQUEST, getStreakLeaderboard);
}
